import * as actions from './actions';
import messages from './messages';

const initState = {
    helpModal: false,
    initialPage: true,
    selectionPage: false,
    summaryPage: false,
    isPartialRollover: false,
    isFullRollover: false,
    uploadPage: false,
    showUploadModal: false,
    message: { header: '', body: '' },
    isVerifyingContent: false,
    isVerificationSuccessful: false,
    isPerformingRollOver: false,
    isRolloverDone: false,
    validationErrors: [],
    rolloverItems: [],
    rolloverSummary: {
        validationErrors: [],
        newStudents: [],
        updatedStudents: [],
        unassignedStudents: [],
        transferredStudents: [],
        newTeachers: [],
        updatedTeachers: [],
        unassignedTeachers: [],
        newClassrooms: [],
        updatedClassrooms: []
    },
    isServerError: false,
    showDataGrid: false,
    showRollOverConfirmation: false,
    rolloverType: '',
    isDownloadingRolloverSignInCards: false,
    includeUnassignedStudents: false,
    includeBulkTransfer: false,
    fileSize: 0
};

const message = { header: '', body: '' };

export default function (state = initState, action) {
    switch (action.type) {
    case actions.ROLLOVER_SHOW_INITIAL_PAGE: {
        return {
            ...state,
            initialPage: true,
            selectionPage: false,
            isPartialRollover: false,
            isFullRollover: false,
            uploadPage: false,
            summaryPage: false
        };
    }
    case actions.ROLLOVER_SHOW_SELECTION: {
        return {
            ...state,
            initialPage: false,
            selectionPage: true,
            isPartialRollover: false,
            isFullRollover: false,
            uploadPage: false,
            summaryPage: false
        };
    }
    case actions.ROLLOVER_SHOW_UPLOAD_PAGE: {
        return {
            ...state,
            initialPage: false,
            selectionPage: false,
            isPartialRollover: false,
            isFullRollover: false,
            uploadPage: true,
            summaryPage: false
        };
    }
    case actions.ON_VIEW_ROLLOVER_SUMMARY: {
        return {
            ...state,
            initialPage: false,
            selectionPage: false,
            isPartialRollover: false,
            isFullRollover: false,
            uploadPage: false,
            summaryPage: true,
            isRolloverDone: false
        };
    }
    case actions.ROLLOVER_SHOW_HELP_MODAL: {
        return {
            ...state,
            helpModal: true
        };
    }
    case actions.ROLLOVER_HIDE_HELP_MODAL: {
        return {
            ...state,
            helpModal: false
        };
    }
    case actions.IS_PARTIAL_ROLLOVER: {
        return {
            ...state,
            isPartialRollover: true,
            isFullRollover: false,
            rolloverType: action.rolloverType
        };
    }
    case actions.IS_FULL_ROLLOVER: {
        return {
            ...state,
            isPartialRollover: false,
            isFullRollover: true,
            rolloverType: action.rolloverType
        };
    }
    case actions.DOWNLOAD_ROLLOVER_TEMPLATE_REQUEST: {
        return {
            ...state,
            isDownloadingTemplate: true,
            isDownloadingTemplateSuccess: false
        };
    }
    case actions.DOWNLOAD_ROLLOVER_TEMPLATE_SUCCESS: {
        return {
            ...state,
            isDownloadingTemplate: false,
            isDownloadingTemplateSuccess: true
        };
    }
    case actions.DOWNLOAD_ROLLOVER_TEMPLATE_FAILURE: {
        return {
            ...state,
            isDownloadingTemplate: false,
            isDownloadingTemplateSuccess: false
        };
    }
    case actions.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_REQUEST: {
        return {
            ...state,
            isDownloadingSchoolRollData: true,
            isDownloadingSchoolRollDataSuccess: false,
            productId: action.productId
        };
    }
    case actions.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_SUCCESS: {
        return {
            ...state,
            isDownloadingSchoolRollData: false,
            isDownloadingSchoolRollDataSuccess: true
        };
    }
    case actions.DOWNLOAD_ROLLOVER_SCHOOL_ROLL_DATA_FAILURE: {
        return {
            ...state,
            isDownloadingSchoolRollData: false,
            isDownloadingSchoolRollDataSuccess: false
        };
    }
    case actions.UPLOAD_ROLLOVER_FAILURE: {
        if (action.isServerError) {
            message.header = messages.errorMessageHeader;
            message.body = messages.errorMessageBody;
        } else {
            message.header = action.errorMessage;
            message.body = action.messageDetail;
        }
        return { ...state,
            showUploadModal: action.showModal,
            message,
            isServerError: action.isServerError,
            showDataGrid: action.showDataGrid,
            isVerificationSuccessful: action.isVerificationSuccessful,
            fileSize: action.fileSize };
    }
    case actions.CLOSE_UPLOAD_ERROR_MODAL: {
        return { ...state,
            showUploadModal: action.showModal,
            message,
            isVerificationSuccessful: action.isVerificationSuccessful,
            validationErrors: action.validationErrors };
    }

    case actions.ROLLOVER_VERIFY_FILE_CONTENT_REQUEST: {
        return { ...state,
            isVerifyingContent: action.isVerifyingContent,
            showDataGrid: action.showDataGrid,
            isVerificationSuccessful: action.isVerificationSuccessful
        };
    }

    case actions.ROLLOVER_VERIFY_FILE_CONTENT_SUCCESS: {
        return { ...state,
            isVerifyingContent: action.isVerifyingContent,
            showUploadModal: action.showUploadModal,
            showDataGrid: action.isVerificationSuccessful,
            isVerificationSuccessful: action.isVerificationSuccessful,
            validationErrors: action.validationErrors,
            rolloverItems: action.rolloverItems
        };
    }

    case actions.ROLLOVER_VERIFY_FILE_CONTENT_FAILURE: {
        message.header = action.message;
        message.body = '';
        return { ...state,
            isVerifyingContent: action.isVerifyingContent,
            showDataGrid: action.showDataGrid,
            isVerificationSuccessful: action.isVerificationSuccessful,
            showUploadModal: action.showUploadModal,
            message };
    }

    case actions.CLEAR_ROLLOVER_VERIFICATION_DATA: {
        return { ...state,
            showDataGrid: false,
            rolloverType: action.rolloverType,
            isVerificationSuccessful: action.isVerificationSuccessful
        };
    }

    case actions.OPEN_ROLLOVER_CONFIRMATION: {
        return { ...state,
            showRollOverConfirmation: action.showRollOverConfirmation
        };
    }

    case actions.CLOSE_ROLLOVER_CONFIRMATION: {
        return { ...state,
            showRollOverConfirmation: action.showRollOverConfirmation
        };
    }

    case actions.ON_ROLLOVER_CONFIRMATION_REQUEST: {
        return { ...state,
            isPerformingRollOver: action.isPerformingRollOver,
            isRolloverDone: action.isRolloverDone,
            showRollOverConfirmation: action.showRollOverConfirmation
        };
    }

    case actions.ON_ROLLOVER_CONFIRMATION_SUCCESS: {
        return { ...state,
            isPerformingRollOver: action.isPerformingRollOver,
            showRollOverConfirmation: action.showRollOverConfirmation,
            isRolloverDone: action.isRolloverDone,
            rolloverSummary: action.rolloverSummary
        };
    }

    case actions.ON_ROLLOVER_CONFIRMATION_FAILURE: {
        message.header = messages.somethingWentWrong;
        message.body = messages.pleaseTryAgain;

        if (action.confirmationErrorMessage) {
            message.header = messages.errorMessageHeader;
            message.body = action.confirmationErrorMessage;
        }

        return { ...state,
            isPerformingRollOver: action.isPerformingRollOver,
            showRollOverConfirmation: action.showRollOverConfirmation,
            isRolloverDone: action.isRolloverDone,
            isVerifyingContent: action.isVerifyingContent,
            showDataGrid: action.showDataGrid,
            isVerificationSuccessful: action.isVerificationSuccessful,
            showUploadModal: action.showUploadModal,
            message
        };
    }

    case actions.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_REQUEST: {
        return { ...state,
            isDownloadingRolloverSignInCards: action.isDownloadingRolloverSignInCards };
    }

    case actions.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_SUCCESS: {
        return { ...state,
            isDownloadingRolloverSignInCards: action.isDownloadingRolloverSignInCards };
    }

    case actions.ON_ROLLOVER_DOWNLOAD_SIGNIN_CARD_FAILURE: {
        return { ...state,
            isDownloadingRolloverSignInCards: action.isDownloadingRolloverSignInCards };
    }

    case actions.ON_INCLUDE_UNASSIGNED_STUDENTS_SELECTION: {
        return { ...state,
            includeUnassignedStudents: !state.includeUnassignedStudents };
    }

    case actions.ON_INCLUDE_BULK_TRANSFER_SELECTION: {
        return { ...state,
            includeBulkTransfer: !state.includeBulkTransfer };
    }

    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/roll-over/reducer.js